import React, {useState} from 'react';
import PropTypes from 'prop-types';
import SelectMultiple from './SelectMultiple/SelectMultiple';
import styles from "./PageSuperPartners.scss";
import ButtonNew from "../../common/primitives/ButtonNew/ButtonNew";

const Questions = ({onSubmitCallBack, questions, questionsObj}) => {

	const [state, setComponentState] = useState({values: {}, labels: {}, allDisabled: []});
	const [visiblePopupId, setPopupVisible] = useState('');


	const showPopup = (id) => {
		setPopupVisible(id);
	}

	const closePopup = () => {
		setPopupVisible('');
	}

	const onChange = (id, option) => {
		let s = state;
		let isMultiSelect = questionsObj.hasOwnProperty(id) ? questionsObj[id].isMultiSelect : 0;

		if (s.values[id] === undefined) {
			s.values[id] = [];
			s.labels[id] = [];
		}

		if (s.values[id].includes(option.value)) {
			if (option.value.includes('all_')) {
				const dIndex = s.allDisabled.indexOf(id);

				if (dIndex > -1) {
					s.allDisabled.splice(dIndex, 1);
				}
			}

			const index = s.values[id].indexOf(option.value);
			if (index > -1) {
				s.values[id].splice(index, 1);
			}
		} else {
			if (isMultiSelect !== 1) {
				s.values[id] = [];
			}

			if (option.value.includes('all_')) {
				s.values[id] = [];
				s.labels[id] = [];
				s.allDisabled.push(id);
			}

			s.values[id].push(option.value);
		}

		if (s.labels[id].includes(option.label)) {
			const index2 = s.labels[id].indexOf(option.label);
			if (index2 > -1) {
				s.labels[id].splice(index2, 1);
			}
		} else {
			if (isMultiSelect !== 1) {
				s.labels[id] = [];
			}

			s.labels[id].push(option.label);

		}

		setComponentState({...s});
	}


	let answeredQuestions = 0;
	let disabled = Object.keys(state.values).length === 0;

	if (!disabled) {
		Object.keys(state.values).map(key => {
			if (state.values[key].length > 0) {
				answeredQuestions += 1;
			}
		});

		disabled = (answeredQuestions !== questions.length);
	}


	const onSubmit = () => {
		if (disabled) {
			return;
		}
		if (typeof onSubmitCallBack === 'function') {
			onSubmitCallBack(state.values);
		}
	}

	return (
	  <div className={styles.selectMultipleContainer}>
		  {
			questions.length > 0 && questions.map((question, key) =>
			  <SelectMultiple
				key={'question_' + key}
				showPopup={() => showPopup(question.id)}
				popupVisible={visiblePopupId === question.id}
				values={state.values.hasOwnProperty(question.id) ? state.values[question.id] : []}
				labels={state.labels.hasOwnProperty(question.id) ? state.labels[question.id] : []}
				closePopup={closePopup}
				question={question.question}
				id={question.id}
				options={question.options}
				allDisabled={state.allDisabled}
				onChange={onChange}/>
			)
		  }

		  <div className={styles.buttonContainer}>
			  <ButtonNew
				value={'Намери партньор'}
				disabled={disabled}
				onClick={onSubmit}/>
		  </div>
	  </div>
	);
}

Questions.defaultProps = {
	questionsObj: {}
}

Questions.propTypes = {
	onSubmitCallBack: PropTypes.func.isRequired,
	questions: PropTypes.arrayOf(PropTypes.shape({
		question: PropTypes.string.isRequired,
		isMultiSelect: PropTypes.number.isRequired,
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		options: PropTypes.arrayOf(PropTypes.shape({
			label: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired
		}))

	})),
	questionsObj: PropTypes.object
}

export default Questions;
